var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampusKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#a)",
    strokeWidth: 1.2,
    d: "M6.154 5.68c-1.882 1.754-1.882 4.624 0 6.377L16.98 22.14l.409.381.408-.38 10.825-10.084-.41-.439.41.439c1.882-1.753 1.882-4.623 0-6.377a4.905 4.905 0 0 0-3.361-1.3c-1.26 0-2.457.458-3.36 1.3l-4.512 4.204-4.512-4.204a4.908 4.908 0 0 0-3.36-1.3c-1.262 0-2.458.458-3.362 1.3Zm20.573 64.784-.302.373.297.377 8.04 10.186h-5.177l-6.268-8.03-.18-.232h-3.604V81.4h-4.344V25.877l-.191-.179L3.193 14.701c-3.457-3.221-3.457-8.444 0-11.665C4.875 1.47 7.118.6 9.515.6c2.396 0 4.64.869 6.322 2.437L16.979 4.1l.41.38.408-.38 1.142-1.063C20.621 1.468 22.863.6 25.26.6c2.397 0 4.64.87 6.322 2.437 3.457 3.22 3.457 8.443 0 11.663L19.724 25.747l-.191.178V69.53H22.443l.18-.225 6.896-8.62h5.131l-7.923 9.78Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 18.253,
    x2: 18.253,
    y1: 0,
    y2: 82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7F1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#18B9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16AAA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampusKey);
export default __webpack_public_path__ + "static/media/campusKey.c7b3f11aaa2e97866f0be6e92f96e78d9c9920fd0ffbfd375afbd4994d218204.svg";
export { ForwardRef as ReactComponent };